import { Text } from 'src/Components'
import { ListingDetailsListing } from 'src/types/listings'
import { useFormattedListingAddress } from 'src/hooks/listings'
import { ListingActionBar } from 'src/Components/ListingDetails/ListingActionBar'

import styles from './MapPanelHeader.module.scss'

export interface MapPanelHeaderProps {
  listing: ListingDetailsListing
}

export const MapPanelHeader = ({ listing }: MapPanelHeaderProps) => {
  const addressObject = useFormattedListingAddress(listing)

  return (
    <ListingActionBar
      listing={listing}
      headingComponent={
        <div className={styles.address}>
          <Text variant='neutralCool' variantCount='900' size='s' weight='bold'>
            {addressObject.firstLineAddress}
          </Text>
          <Text
            variant='neutralCool'
            variantCount='700'
            size='s'
            weight='regular'
          >
            {addressObject.secondLineAddress}
          </Text>
        </div>
      }
    />
  )
}
